module.exports = __webpack_public_path__ + "img/w-wa_logo.ff3f2319.png";